// generated from 68_168 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const languageFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("language_filter"),
  comparison_key: z.enum([
    "1", // 60_954 (89.42%)
    "2", // 5_517 (8.09%)
    "25", // 1_210 (1.78%)
    "26", // 455 (0.67%)
    "11", // 25 (0.04%)
    "12", // 7 (0.01%)
  ]),
  display_name: z.string(),
  // undefined: 13_983 (20.51%), defined 54_185 (79.49%)
  raw_value: z
    .union([
      // string samples: 53_278 (98.33%)
      z.string(),
      // array samples: 907 (1.67%)
      z.array(z.string()),
    ])
    .optional(),
  value: z.union([
    // array samples: 1_665 (2.44%)
    z.array(
      z.object({
        id: z.string(),
        value: z.string(),
      })
    ),
    // object samples: 66_503 (97.56%)
    z.object({
      id: z.string(),
      value: z.string(),
    }),
  ]),
  varies_by_app_group: z.literal(false),
});
